import React from 'react';
import { BaseConfig } from '../BaseConfig';
import ContnueButton from '../ui/ContinueButton';
import { UIProperties } from '../UIProperties';

import './FailAlert.css'
import { GeneralButtonConfig } from './GeneralButton';

const FailAlert = (props: UIProperties<FailAlertConfig>) => {
	return (
		<div aria-label={props.parameters.title} className="in-game-ui-container ui-top-most-container modal-disable-select">
			{props.parameters.smallerTitle ?
			(
				<div aria-label={props.parameters.title} className="failalert-container center-on-container">
				<img src="./assets/images/general/components/general_alert/window_mentor.png"/>
				<p className="failalert-title title-font" style={{fontSize: '18pt'}}></p>
				<div className="failalert-desc-container">
					<div className="failalert-desc-left-small">
						<img className="center-on-container" src={props.parameters.img}/>
					</div>
					<div className="failalert-desc-right" style={{
						width: '464px',
						position: 'absolute',
						height: '245px',
						right: '10px'
					}}>
						<p tabIndex={0} id='first-object-failalert' className="failalert-desc-small regular-description-font" style={{
							position: 'absolute',
							transform: 'translate(0, -50%)',
							margin: 0
						}}>{props.parameters.text}</p>
						<ContnueButton parameters= {{
							ariaLbl: props.parameters.unseenText ?? 'try again',
							id:'last-object-failalert',
							srcMain: props.parameters.srcMain ? props.parameters.srcMain : './assets/images/general/components/general_alert/button_tryagain.png',
							srcDown: props.parameters.srcDown ? props.parameters.srcDown : './assets/images/general/components/general_alert/button_tryagain_down.png',
							srcDisabled: props.parameters.srcDisabled ? props.parameters.srcDisabled : './assets/images/general/components/general_alert/button_tryagain.png',
							top: '230px',
							left: '500px',
							width: '200px',
							onClicked: props.parameters.onContinueClicked
						}}/>
					</div>
				</div>
			</div>
			) :
			(
				<div className="failalert-container center-on-container">
				<img src="./assets/images/general/components/general_alert/window_side_large_blank.png"/>
				<p className="failalert-title title-font">{props.parameters.title}</p>
				<div className="failalert-desc-container">
					<div className="failalert-desc-left">
						<img className="center-on-container" src={props.parameters.img}/>
					</div>
					<div className="failalert-desc-right" style={{
						width: '464px',
						position: 'absolute',
						height: '245px',
						right: '10px'
					}}>
						<p tabIndex={0} id='first-object-failalert' className="failalert-desc regular-description-font" style={{
							position: 'absolute',
							transform: 'translate(0, -50%)',
							margin: 0
						}}>{props.parameters.text}</p>
						<ContnueButton parameters= {{
							ariaLbl: props.parameters.unseenText ?? 'try again',
							id:'last-object-failalert',
							srcMain: props.parameters.srcMain ? props.parameters.srcMain : './assets/images/general/buttons/button_close_main.png',
							srcDown: props.parameters.srcDown ? props.parameters.srcDown : './assets/images/general/buttons/button_close_down.png',
							srcDisabled: props.parameters.srcDisabled ? props.parameters.srcDisabled : './assets/images/general/buttons/button_close_main.png',
							top: '600px',
							left: '120px',
							width: '200px',
							onClicked: props.parameters.onContinueClicked
						}}/>
					</div>
				</div>
			</div>
			)}
			
		</div>
	);

};

export interface FailAlertConfig extends BaseConfig {
	title?: string;
	srcMain?: string;
	srcDown?: string;
	srcDisabled?: string;
	text: string;
	smallerTitle?: boolean;
	unseenText?: string;
	img: string;
	onContinueClicked: () => void;
}

export default FailAlert;